import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              韩国漫画网是领先的中文韩漫在线阅读平台，提供最新最全的韩国免费漫画，支持下拉式流畅阅读体验。每日更新，分类齐全，为广大韩漫爱好者打造极致的在线阅读空间。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-background-50/50 mt-0.5"></i>
                <span className="text-sm text-background-50/60">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-background-50/50 mt-0.5"></i>
                <span className="text-sm text-background-50/60">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-background-50/50 mt-0.5"></i>
                <span className="text-sm text-background-50/60">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
            <p className="text-xs text-background-50/40">
              &copy; {currentYear} {siteInfo.name} 版权所有 | 韩漫大全 - 下拉式漫画全集在线阅读
            </p>
            <div className="flex items-center gap-4">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="text-background-50/40 hover:text-background-50/70 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="nofollow noopener noreferrer" className="text-background-50/40 hover:text-background-50/70 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="text-background-50/40 hover:text-background-50/70 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}